import React from 'react';
import About from '../components/About.js';
import SEO from '../components/SEO.js';

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About Vijay Industry",
  "url": "https://vijayindustry.co.in/about",
  "description": "Learn about Vijay Industry, trusted PEB structure manufacturers and industrial steel fabricators in Coimbatore since 2011.",
  "mainEntity": {
    "@type": "Organization",
    "name": "Vijay Industry",
    "foundingDate": "2011",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Coimbatore",
      "addressRegion": "Tamil Nadu",
      "addressCountry": "IN"
    }
  }
};

export default function AboutPage() {
  return (
    <div className="page-about animate-fade-in">
      <SEO 
        title="About Vijay Industry | Steel Structure Manufacturers & Engineers"
        description="Learn about Vijay Industry, trusted PEB structure manufacturers and industrial steel fabricators in Coimbatore with over 15 years of engineering experience."
        keywords="About Vijay Industry, Steel Structure Manufacturers Coimbatore, PEB Engineers Tamil Nadu, Industrial Fabricators Coimbatore"
        canonical="/about"
        schemaData={aboutSchema}
      />
      {/* Page Header Banner */}
      <div 
        style={{ 
          backgroundColor: 'var(--primary)', 
          color: 'var(--surface)', 
          padding: '4rem 0',
          position: 'relative',
          overflow: 'hidden',
          borderBottom: '4px solid var(--accent)'
        }}
      >
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <h1 style={{ color: 'var(--surface)', fontSize: '2.5rem', marginBottom: '0.5rem' }}>
            About Us
          </h1>
          <p style={{ color: '#94A3B8', maxWidth: '600px', fontSize: '1.1rem' }}>
            Built on trust, quality craftsmanship, and experienced structural engineering since 2011.
          </p>
        </div>
      </div>

      {/* About Component */}
      <About />
    </div>
  );
}
